import { Project, Subscription } from "@packages/client";

export const OrganizationProjectStatusesTypes = {
  active: "active",
  deleted: "deleted",
  requested: "requested",
  failed: "failed",
  suspended: "suspended"
} as const;

export interface OrganizationProject {
  id: string;
  organization_id: string;
  subscription_id: string;
  region: string;
  title: string;
  type: string;
  plan: string;
  default_branch: string;
  access_migration_status: string; // TODO - what are the possible values?
  status: (typeof OrganizationProjectStatusesTypes)[keyof typeof OrganizationProjectStatusesTypes];
  vendor: string;
  created_at: string;
  updated_at: string;
  subscribe: Project["subscribe"];
  // Metadata migrated from the subscriptions endpoint (CON-516). The backend
  // omits these when empty rather than sending defaults, so they are all
  // optional and must be read defensively (presence checks, never `=== ""`).
  support_tier?: string;
  fastly_service_ids?: string[] | null;
  // Renamed from the subscription's `enterprise_tag`. ABSENT when the project
  // has no dedicated tag — use `Boolean(dedicated_tag)`, not `!== ""`.
  dedicated_tag?: string;
  // Reuses the subscription's shape so existing nested reads typecheck unchanged.
  project_options?: Subscription["project_options"];
  options_custom?: Subscription["options_custom"];
  trial_plan?: boolean;
  agency_site?: boolean;
  timezone?: string;
  locked?: boolean;
  cse_notes?: string;
  billing_profile_id?: string;
  _links: {
    // Can be used to check if the current user has access to the project
    api?: { href: string };
    self: { href: string };
    update?: { href: string };
    delete?: { href: string };
    subscription: { href: string };
    plan_uri?: { href: string };
  };
}

export type OrganizationRefProject = {
  created_at: string;
  id: string;
  organization_id: string;
  region: string;
  title: string;
  updated_at: string;
};

export type OrganizationProjectResponse = Record<
  string,
  // The api can return null in some situations on staging
  OrganizationRefProject | null
>;

export interface OrganizationProjectsList {
  count: number;
  facets: {
    plans?: Record<string, string>;
  };
  items: OrganizationProject[];
  _links: {
    previous?: {
      href: string;
    };
    next?: {
      href: string;
    };
  };
}
